import { some, none, Option } from "widgets-for-react"

export namespace DataLayer {
  export const clickToShop = () => (
    DatalayerApi.push({
      category: "Shop",
      action: 'button in header',
      label: window.location.pathname
    })
  )

  export const clickToMyAccount = () => (
    DatalayerApi.push({
      category: "Mijn BSL",
      action: 'button in header',
      label: window.location.pathname
    })
  )

  export const clickToEvent = (eventUrl: string) => (
    DatalayerApi.push({
      category: "Events - Block",
      action: eventUrl,
      label: window.location.pathname
    })
  )

  export const clickToJob = (jobTitle: string) => (
    DatalayerApi.push({
      category: "Sollicitatie",
      action: 'click naar formulier',
      label: jobTitle
    })
  )

  export const clickOnContact = (medium: 'Mail' | 'Call') => (
    DatalayerApi.push({
      category: "Contact",
      action: medium,
      label: window.location.pathname
    })    
  )

  export const playVideo = () => (
    DatalayerApi.push({
      category: "Video",
      action: 'play',
      label: window.location.pathname
    })    
  )
}

namespace DatalayerApi {
  interface DataLayerApi {
    push: (data: {}) => void
  }

  export const getDatalayer: () => Option<DataLayerApi> = () => (window["dataLayer"] ? some(window["dataLayer"]) : none())

  export const push: (data: any) => void = data => {
    const datalayer = getDatalayer()

    let eventData = {
      event: "event.bsl",
      ...data
    }

    if (datalayer.v.kind == "r") {
      datalayer.v.v.push(eventData)
    } else {
      console.log("DataLayer not found, failed to push event", eventData)
    }
  }
}
